var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"src":_vm.src,"controls":""},on:{"mouseenter":_vm.enter,"mouseleave":_vm.out}})}
var staticRenderFns = []

export { render, staticRenderFns }